import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "src/components/Dialog";
import usePrevious from "src/utils/usePrevious";
import GetStartedDialogTitle from "src/pages/GetStarted/DialogTitle";

const ExtensionUrl =
  "https://chromewebstore.google.com/detail/my-reseller-genie-web-ext/dmlldabapacmdgndabfmihemkgegcmfc";

export function Content({
  platform: _platform,
  update: _update,
  onClose,
}: {
  platform?: string;
  update?: boolean;
  onClose?: () => void;
}) {
  const [clicked, setClicked] = useState(false);
  const platformMemory = usePrevious(_platform);
  const platform = _platform || platformMemory || "Poshmark";
  const updateMemory = usePrevious(_update);
  const update = _update === undefined ? updateMemory || false : _update;
  const title = clicked
    ? "Load Extension"
    : `${update ? "Update" : "Add"} Extension`;

  return (
    <>
      {onClose ? (
        <GetStartedDialogTitle onClose={onClose}>{title}</GetStartedDialogTitle>
      ) : (
        <DialogTitle>{title}</DialogTitle>
      )}
      <DialogContent>
        <DialogContentText>
          {clicked
            ? "Click below to load the extension."
            : `Click below to download the My Reseller Genie Extension. This will allow you to import your data from ${platform}.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {clicked ? (
          <Button
            color="primary"
            autoFocus
            onClick={() => window.location.reload()}
          >
            Load Extension
          </Button>
        ) : (
          <Button
            component="a"
            color="primary"
            autoFocus
            onClick={() => setClicked(true)}
            {...({
              href: ExtensionUrl,
              target: "_blank",
            } as any)}
          >
            Get Extension
          </Button>
        )}
      </DialogActions>
    </>
  );
}
function AddPoshmarkExtensionDialog({
  open,
  onClose,
  platform,
  update,
}: {
  open: boolean;
  onClose: () => void;
  platform?: string;
  update?: boolean;
}) {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <Content platform={platform} update={update} />
    </Dialog>
  );
}

export default AddPoshmarkExtensionDialog;
